"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.WindowOffsetType = exports.SimplePosType = exports.NearLocType = exports.IsOnScreenType = exports.DomPositionInfoType = exports.DomInfoType = exports.Coordinate = exports.CalWindowOffsetResult = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("reshow-runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("reshow-runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("reshow-runtime/helpers/createSuper"));
var _createClass2 = _interopRequireDefault(require("reshow-runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("reshow-runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("reshow-runtime/helpers/defineProperty"));
var _getoffset = require("getoffset");
var _getScrollInfo = require("get-scroll-info");
// @ts-check
/**
 * @typedef {import("reshow-constant").SAFE_UNDEFINED} SAFE_UNDEFINED
 */
/**
 * @typedef {SAFE_UNDEFINED|HTMLElement} MaybeHTMLElement
 */
var NearLocType = exports.NearLocType = /*#__PURE__*/(0, _createClass2["default"])(function NearLocType() {
  (0, _classCallCheck2["default"])(this, NearLocType);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "center", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "centerCenter", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "top", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "bottom", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "left", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "right", void 0);
});
var Coordinate = exports.Coordinate = /*#__PURE__*/(0, _createClass2["default"])(function Coordinate() {
  (0, _classCallCheck2["default"])(this, Coordinate);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "x", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "y", void 0);
});
var SimplePosType = exports.SimplePosType = /*#__PURE__*/(0, _createClass2["default"])(function SimplePosType() {
  (0, _classCallCheck2["default"])(this, SimplePosType);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "top", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "right", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "bottom", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "left", void 0);
});
var DomInfoType = exports.DomInfoType = /*#__PURE__*/function (_OffsetType) {
  (0, _inherits2["default"])(DomInfoType, _OffsetType);
  var _super = (0, _createSuper2["default"])(DomInfoType);
  function DomInfoType() {
    var _this;
    (0, _classCallCheck2["default"])(this, DomInfoType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * @type MaybeHTMLElement
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "domScroller", void 0);
    /**
     * @type MaybeHTMLElement
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fixedNode", void 0);
    /**
     * @type MaybeHTMLElement
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "overflowNode", void 0);
    return _this;
  }
  return (0, _createClass2["default"])(DomInfoType);
}(_getoffset.OffsetType);
var IsOnScreenType = exports.IsOnScreenType = /*#__PURE__*/function (_DomInfoType) {
  (0, _inherits2["default"])(IsOnScreenType, _DomInfoType);
  var _super2 = (0, _createSuper2["default"])(IsOnScreenType);
  function IsOnScreenType() {
    var _this2;
    (0, _classCallCheck2["default"])(this, IsOnScreenType);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    /**
     * @type boolean
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "isOnScreen", void 0);
    /**
     * @type boolean
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "atTop", void 0);
    /**
     * @type boolean
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "atRight", void 0);
    /**
     * @type boolean
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "atBottom", void 0);
    /**
     * @type boolean
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "atLeft", void 0);
    return _this2;
  }
  /**
   * @type boolean
   */
  return (0, _createClass2["default"])(IsOnScreenType);
}(DomInfoType);
var DomPositionInfoType = exports.DomPositionInfoType = /*#__PURE__*/(0, _createClass2["default"])(function DomPositionInfoType() {
  (0, _classCallCheck2["default"])(this, DomPositionInfoType);
  /**
   * @type DomInfoType
   */
  (0, _defineProperty2["default"])(this, "domOverflowInfo", void 0);
  /**
   * @type DomInfoType
   */
  (0, _defineProperty2["default"])(this, "domInfo", void 0);
  /**
   * @type MaybeHTMLElement
   */
  (0, _defineProperty2["default"])(this, "fixedNode", void 0);
  /**
   * @type MaybeHTMLElement
   */
  (0, _defineProperty2["default"])(this, "overflowNode", void 0);
});
var CalWindowOffsetResult = exports.CalWindowOffsetResult = /*#__PURE__*/(0, _createClass2["default"])(function CalWindowOffsetResult() {
  (0, _classCallCheck2["default"])(this, CalWindowOffsetResult);
  /**
   * @type string[]
   */
  (0, _defineProperty2["default"])(this, "locs", void 0);
  /**
   * @type string
   */
  (0, _defineProperty2["default"])(this, "firstKey", void 0);
  /**
   * @type string
   */
  (0, _defineProperty2["default"])(this, "secondKey", void 0);
});
var WindowOffsetType = exports.WindowOffsetType = /*#__PURE__*/function (_CalWindowOffsetResul) {
  (0, _inherits2["default"])(WindowOffsetType, _CalWindowOffsetResul);
  var _super3 = (0, _createSuper2["default"])(WindowOffsetType);
  function WindowOffsetType() {
    var _this3;
    (0, _classCallCheck2["default"])(this, WindowOffsetType);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this3 = _super3.call.apply(_super3, [this].concat(args));
    /**
     * @type IsOnScreenType
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this3), "domOverflowInfo", void 0);
    /**
     * @type IsOnScreenType
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this3), "domInfo", void 0);
    /**
     * @type ScrollInfoType
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this3), "scrollInfo", void 0);
    return _this3;
  }
  return (0, _createClass2["default"])(WindowOffsetType);
}(CalWindowOffsetResult);